import styled from 'styled-components';
import { colors } from "../../../utils/colors";

export const Form = styled.form`
    display: flex;
    flex-direction: column;
    width: 90%;
    max-width: 500px;
    margin: 50px auto 0;
        div{
            position: relative;
            margin: 5px 0;
            label {
                color: ${colors.BLUE};
            }
            input{
                border: none;
                background: inherit;
                border-bottom: 2px solid white;
                border-radius: 5px;
                width: 100%;
                margin-top: 10px;
                margin-bottom: 15px;
                color: ${colors.BLUE};
                padding: 10px;
                box-shadow: 0 3px 3px -2px rgba(0,0,0,.2),
                            0 3px 4px 0 rgba(0,0,0,.14),
                            0 1px 8px 0 rgba(0,0,0,.12);
            }
            textarea{
                width: 100%;
                border: none;
                background: inherit;
                border-bottom: 2px solid white;
                margin-top: 10px;
                margin-bottom: 15px;
                color: ${colors.BLUE};
                padding: 10px;
                border-radius: 5px;
                box-shadow: 0 3px 3px -2px rgba(0,0,0,.2),
                            0 3px 4px 0 rgba(0,0,0,.14),
                            0 1px 8px 0 rgba(0,0,0,.12);
            }
        }
        button{
            background-color: ${colors.CREAM};
            color: ${colors.BLUE};
            font-family: 'Dancing Script', cursive;
            border: none;
            padding: 10px 0;
            border-radius: 15px;
            max-width: 200px;
            width: 100%;
            -webkit-box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);
            -moz-box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);
            box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);
            transition: .3s ease-in;
            align-self: flex-end;

            &:hover{
                cursor: pointer;
                transform: translateY(-2px);
                transition: .3s ease-in;
            }
        }
        
    @media (max-width: 1200px) {
        margin-bottom: 50px;
    }
`;